
define(
	'Code25.CaterpartsGlobal.WhatsApp.View'
	, [
		"Handlebars", "Utils", "Code25.whatsapp.tpl", "Tools", 'js.cookie'
	]
	, function (
		Handlebars, Utils, Code25_whatsapp_tpl, Tools, Cookies
	) {
		'use strict';


		var slideIn

		return Backbone.View.extend({

			template: Code25_whatsapp_tpl,
			initialize: function (options) {

			},
			close: function (e) {
				e.stopPropagation();
				e.preventDefault();
				// Cookies.set('AD', "X", { expires: 31 });
				// this.render();
			}
			, events: {
				// 'click [data-action="close"]': 'close',
			},
			getContext: function getContext() {
				
				return {

				};
			}
		});

	});



